<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <Roteirization />
    </PageRowWrapper>

  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import Roteirization from '@/components/settings/integrador/roteirization/Roteirization'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'Roteirizations',
  components: {
    PageTitle,
    PageRowWrapper,
    Roteirization,
    LoadingPage
  }
}
</script>
